import React from 'react';
import { formatDuration } from '../../../src/js/lib/duration';
import { formatNumber } from '../../../src/js/lib/number';
import BarLoader from 'react-spinners/BarLoader';
import Pagination from '../../Pagination';
import apiFetch from '../../../src/js/fetch';
import Container from '../../ContentContainer';
import ContestantName from '../ContestantName';
import ProfilePicture from '../../Athletes/ProfilePicture';
import { updatePodium } from '../../../src/js/contests/leaderboard';

class DistanceLeaderboard extends React.Component {
  constructor(props) {
    super(props);

    this.followingFilter = document.querySelector('[name="filterFollowing"]');
    this.countryFilter = document.querySelector('[name="filterCountry"]');
    this.monthFilter = document.querySelector('[name="filterMonth"]');
    this.genderFilter = document.querySelector('[name="filterGender"]');

    this.state = {
      initialFetched: false,
      contestId: props.contest_id,
      challengeType: props.distance_challenge_type,
      userId: props.user_id,
      contestants: [],
      activitiesGroupedMonthly: [],
      loading: true,
      contestMonths: props.contest_months,
      contestantCountries: props.contestant_countries,

      numPages: 1,
      currentPage: 1,
      perPage: null,

      orderBy: 'total_distance_in_meters',
      filterGender: this.genderFilter?.value || 'all',
      filterMonth: this.monthFilter?.value || 'all',
      filterCountry: this.countryFilter?.value || 'all',
      filterFollowing: this.followingFilter?.value || 'all',
      openFilter: false,
    };

    this.currentPositionButton = document.querySelector(
      '[data-current_position]'
    );
  }

  componentDidMount() {
    this.fetchContestants(this.state.currentPage);

    // Add the reloadLeaderboard function to the window object so it can be called from the outside
    window.reloadLeaderboard = this.reloadLeaderboard;

    // Listen for clicks outside the filter dropdown
    document.body.addEventListener('click', this.handleClickOutsideFilter);

    // Listen for filter changes
    this.countryFilter.addEventListener('change', this.onChange);
    this.monthFilter.addEventListener('change', this.onChange);
    this.genderFilter.addEventListener('change', this.onChange);
    this.followingFilter.addEventListener('change', this.onChange);

    // Listen for clicks on the current position button that will take the user to the page where the user is
    this.currentPositionButton.addEventListener('click', this.goToPositionPage);

    // Display month filter
    document.querySelector('[name="filterMonth"]').classList.remove('hidden');
  }

  reloadLeaderboard = () => {
    this.setState({ currentPage: 1, contestants: [], loading: true }, () => {
      this.fetchContestants(this.state.currentPage);
    });
  };

  componentWillUnmount() {
    window.reloadLeaderboard = null;
    document.body.removeEventListener('click', this.handleClickOutsideFilter);

    this.countryFilter.removeEventListener('change', this.onChange);
    this.monthFilter.removeEventListener('change', this.onChange);
    this.genderFilter.removeEventListener('change', this.onChange);
    this.followingFilter.removeEventListener('change', this.onChange);

    this.currentPositionButton.removeEventListener(
      'click',
      this.goToPositionPage
    );
  }

  goToPositionPage = (e) => {
    const position = this.currentPositionButton.getAttribute(
      'data-current_position'
    );

    window.scrollTo({
      top:
        document.querySelector('.leaderboard').getBoundingClientRect().top +
        window.scrollY -
        100,
      behavior: 'smooth',
    });

    if (position && this.state.perPage) {
      // Calculate the page based on the position
      const page = Math.ceil(parseInt(position) / this.state.perPage);

      console.log({ page, perPage: this.state.perPage, position });
      this.onPaginate(page);
    }
  };

  onPaginate = (page) => {
    if (page !== this.state.currentPage) {
      this.setState({ currentPage: page }, () => {
        this.fetchContestants(page);
      });
    }
  };

  fetchContestants = async (page) => {
    this.setState({ loading: true });

    const {
      contestId,
      filterCountry,
      filterMonth,
      filterGender,
      filterFollowing,
      initialFetched,
    } = this.state;
    try {
      const data = await apiFetch(`/api/challenges/leaderboard`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contest_id: contestId,
          page: page,
          filter: {
            gender: filterGender,
            country: filterCountry,
            following: filterFollowing,
          },
          order: {
            month: filterMonth,
            // field: orderBy,
          },
        }),
      });

      // console.log({ data });

      this.setState({
        initialFetched: true,
        contestants: data.contestants,
        activitiesGroupedMonthly: data.monthly_grouped_activities,
        numPages: data.total_pages,
        perPage: data.per_page,
      });
      if (initialFetched) {
        updatePodium(data.contestants, data.filtered, page);
      }
    } catch (e) {
      console.log({ e });
      const err = e.json ? await e.json() : null;
      console.log({ err });

      this.setState({
        loading: false,
        error:
          (err && err.error_message) ||
          'Something went wrong. Please try again later.',
      });
    }
    this.setState({ loading: false });
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, currentPage: 1 }, () => {
      this.fetchContestants(1);
    });
  };

  handleClickOutsideFilter = (e) => {
    if (
      this.state.openFilter &&
      !e.target.closest('.challenge-leaderboard-filter') &&
      !e.target.closest('.filter-trigger')
    ) {
      this.setState({ openFilter: false });
    }
  };

  render() {
    const {
      contestants,
      activitiesGroupedMonthly,
      numPages,
      currentPage,
      userId,
      contestMonths,
      filterMonth,
    } = this.state;

    return (
      <Container classes='leaderboard'>
        <h2 className='mini-label font-medium'>Leaderboard</h2>
        <div className='w-full overflow-x-auto challenge-leaderboard'>
          <table className='w-full border-spacing-y-2 border-separate'>
            <thead className=''>
              <tr className=''>
                <th className=''>#</th>
                <th className=''>Contestant</th>
                <th className=''>Total km</th>
                {contestMonths.map((month, i) => {
                  const mnth = `${month[1]}-${('0' + month[0]).slice(-2)}-01`;
                  return (
                    <th
                      key={`${month[0]}-${month[1]}`}
                      className={
                        filterMonth === mnth
                          ? 'leaderboard__row-item-highlight'
                          : ''
                      }
                    >
                      {month[2]}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {contestants.map((contestant, i) => (
                <tr
                  key={contestant.id}
                  className={`${
                    contestant.user_id === userId ? 'current-user' : ''
                  }`}
                >
                  <td className=''>
                    {contestant.filtered
                      ? contestant.period_total_distance_in_meters > 0 // if filtered, we have the period_total_distance_in_meters field.
                        ? `${i + 1}.`
                        : '-'
                      : contestant?.position && contestant.position > 0
                      ? `${contestant.position}.`
                      : '-'}
                  </td>
                  <td className='flex items-center'>
                    <ProfilePicture {...contestant.user} />
                    <ContestantName contestant={contestant} userId={userId} />
                  </td>
                  <td className=''>
                    {contestant.total_distance_in_meters
                      ? formatNumber(
                          (contestant.total_distance_in_meters / 1000).toFixed(
                            0
                          )
                        )
                      : '0'}{' '}
                    km
                  </td>
                  {contestMonths.map((month, i) => {
                    const mnth = `${month[1]}-${('0' + month[0]).slice(-2)}-01`;
                    const activityMonth = activitiesGroupedMonthly.find(
                      (m) => m.month === mnth
                    );
                    const distance = activityMonth?.users?.find(
                      (u) => u.id === contestant.user_id
                    )?.total_distance_in_meters;

                    return (
                      <td
                        key={`${month[2]}-${contestant.id}`}
                        className={
                          filterMonth === mnth
                            ? 'leaderboard__row-item-highlight'
                            : ''
                        }
                      >
                        {distance
                          ? `${formatNumber((distance / 1000).toFixed(0))}km`
                          : '-'}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>

          {this.state.loading ? <BarLoader /> : null}

          <Pagination
            numPages={numPages}
            currentPage={currentPage}
            onPaginate={this.onPaginate}
          />
        </div>
      </Container>
    );
  }
}
export default DistanceLeaderboard;
